import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import AccountInfo from './AccountDetails/AccountInfo'
import MyOrders from './MyOrders'
import { ServiceCenter } from '@/components/Account/ServiceCenter'
import { useBackend } from '@/src/providers/BackendProvider'
import Index from '@/components/Account/ContactAudiologist'

const AccountRouter = (props) => {
  const currentView = props.currentView
  const userInfo = props.info
  // console.log(currentView)

  const { loading } = useBackend()

  const res = useMemo(() => {
    if (loading) {
      return <div />
    }
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          maxWidth: '912px',
          width: '60vw'
        }}
      >
        {currentView === 'detail' && <AccountInfo info={userInfo} />}
        {currentView === 'service' && (
          <ServiceCenter
            isKYCSubmitDone={props.isKYCSubmitDone}
            prefittingStat={props.prefittingStat}
          />
        )}
        {currentView === 'orders' && <MyOrders info={userInfo} />}
        {currentView === 'audiologist' && <Index />}
      </Box>
    )
  }, [loading, currentView])

  return <>{res}</>
}

export default AccountRouter
